import Request from '../../../../src/core/gd/data/request'
import isMoment from "../utils/datetime/is-moment";


export default class ApiEvents {

    constructor() {

    }

    getEvent(eventId:ID) {
        return new Request(this,'GET','event/'+eventId);
    }

    viewEvent(eventId:ID) {
        return new Request(this,'GET','event/{0}/view'.f(eventId), {}, true, false);
    }

    // couldn't find usages... is it old ?
    all(startMoment:Moment,endMoment:Moment) {
        return new Request(this,'GET','events',{
            startDate: gd.utils.momentToDate(startMoment),
            endDate: gd.utils.momentToDate(endMoment)
        });
    }

    assignTo(eventId:ID, userId:ID) {
        return new Request(this,'put','event/'+eventId+'/assign',{
            'userId': userId
        });
    }

    setStartEnd(eventId:ID, startMoment:Moment | null, endMoment:Moment | null) {
        return new Request(this, 'PUT', 'event/'+eventId+'/start-end', {
            startDate: gd.utils.momentToDate(startMoment),
            endDate: gd.utils.momentToDate(endMoment)
        });
    }

    static create(params:any) {


        // Prepare dates
        if (isMoment(params.startDate)) {
            params.startDate = gd.utils.momentToDate(params.startDate);
        }
        if (params.endDate && isMoment(params.endDate)) params.endDate = gd.utils.momentToDate(params.endDate);

        const request = new Request(this,'post','events',params);

        request.done(response=>{
            gd.growl.eventCreated(response.id, response.name);
        });

        return request;
    }

    deleteEvent(eventId:ID) {
        return new Request(this,'DELETE','event/'+eventId)
    }

    setName(eventId:ID, name:string) {
        return new Request(this, 'PUT', 'event/{0}/update'.f(eventId), {name});
    }

    setNotes(eventId:ID, notes:string) {
        return new Request(this,'PUT','event/{0}/notes'.f(eventId),{notes});
    }

    setAccomplished(eventId:ID, isAccomplished:boolean) {
        return new Request(this,'PUT','event/{0}/accomplished'.f(eventId),{isAccomplished});
    }

    setProjectId(eventId:ID, projectId:ID) {
        return new Request(this, 'PUT', 'event/{0}/update'.f(eventId), {projectId});
    }
}

